import React from 'react'
import { Skeleton } from '@material-ui/lab'

const LoadingsSlot: React.FC = () => {
  return (
    <>
      <div style={{ height: '100%', width: '100%', maxWidth: '400px', margin: 'auto' }}>
        <Skeleton variant="rect" width="100%" height="50px" style={{ marginTop: 16 }} />
        <Skeleton variant="rect" width="100%" height="50px" style={{ marginTop: 16 }} />
        <Skeleton variant="rect" width="100%" height="50px" style={{ marginTop: 16 }} />
        <Skeleton variant="rect" width="100%" height="50px" style={{ marginTop: 16 }} />
        <Skeleton variant="rect" width="100%" height="50px" style={{ marginTop: 16 }} />
        <Skeleton variant="rect" width="100%" height="50px" style={{ marginTop: 16 }} />
        <Skeleton variant="rect" width="100%" height="50px" style={{ marginTop: 16 }} />
      </div>
    </>
  )
}

export default LoadingsSlot
